import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";

import { logout } from "../slices/auth";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={"[class*='MuiDialogContent-root']"}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function LogOut({ open, close }) {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [processing, setProcessing] = useState(false);

  const handlelogout = async () => {

    if (processing) return;

    setProcessing(true);

    try {
      // 1. clear redux state
      dispatch(logout());

      // 2. clear storage
      localStorage.removeItem("user");
      sessionStorage.removeItem("user");
      localStorage.removeItem("rememberMe");

      // 3. navigate immediately
      navigate("/login", { replace: true });

      // 4. close dialog
      close();

    } catch (err) {
      console.log("Logout error:", err);

    } finally {
      setProcessing(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle id="draggable-dialog-title">
        Logout Option...
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to logout from the current session?
        </DialogContentText>
      </DialogContent>

      <DialogActions>

        <Button
          onClick={handlelogout}
          color="error"
          disabled={processing}
        >
          Yes
        </Button>

        <Button
          onClick={close}
          disabled={processing}
        >
          No
        </Button>

      </DialogActions>
    </Dialog>
  );
}